import React from 'react'
import { useSelector } from 'react-redux'
import { ChirpThemeProvider } from '@chewy/chirp-theme-provider'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

export const ChirpThemeWrapper: React.FC = () => {
  const isRhapsodyThemeEnabled = useSelector(
    getFeatureToggle(FeatureToggle.USE_RHAPSODY_THEME),
  )

  const theme = isRhapsodyThemeEnabled ? 'rhapsody' : 'enterprise'

  return <ChirpThemeProvider env="PRD" themes={[theme]} />
}
